import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

const sizeMap: Record<string, string> = {
  xs: "max-w-xs",
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
};

export function CustomModal({
  button,
  children,
  size,
  onOpenChange,
  open,
}: any) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      {button && <DialogTrigger asChild>{button}</DialogTrigger>}
      <DialogContent
        className={cn(
          "p-0 text-left items-start rounded-[4px] bg-background",
          size ? sizeMap[size] || "max-w-xs" : "max-w-xs"
        )}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
